module.exports = __webpack_public_path__ + "img/mediothek.4aa8d24e.gif";